
import { defineComponent } from 'vue'

export default defineComponent({
  data: function () {
    return {
      date: new Date(),
    }
  },
  created () {
    setInterval(() => {
      this.updateDate()
    }, 1000)
  },
  methods: {
    updateDate () {
      this.date = new Date()
    },
    formatearFechaHora (fecha: Date): string {
      const day = fecha.getDate().toString().padStart(2, '0')
      const month = (fecha.getMonth() + 1).toString().padStart(2, '0')
      const hours = fecha.getHours().toString().padStart(2, '0')
      const minutes = fecha.getMinutes().toString().padStart(2, '0')
      const seconds = fecha.getSeconds().toString().padStart(2, '0')

      return `${day}-${month}-${fecha.getFullYear()} ${hours}:${minutes}:${seconds}`
    },
  },
})
